import React, { useEffect } from 'react';
import { useProfileStore } from '@/core/application/state/useProfileStore';
import { useRoleStore } from '@/core/application/state/useRoleStore';
import { OnboardingStorage, useClinicalOnboarding } from '@/core/application/profile/useClinicalOnboarding';
import { DynamicLoader } from '@/shared/components/DynamicLoader';
import { useNavigate } from 'react-router-dom';

export function AuthDispatcherScreen() {
  const { setActiveRole } = useRoleStore();
  const { verifyPendingInvite } = useClinicalOnboarding();
  const navigate = useNavigate();

  useEffect(() => {
    dispatchAuth();
  }, []);

  const processPendingInvite = async () => {
    const pendingCode = await OnboardingStorage.getPendingInvite();
    if (!pendingCode) return false;

    const validation = await verifyPendingInvite(pendingCode);

    if (validation.es_valido) {
      return true;
    }

    await OnboardingStorage.clearPendingInvite();
    if (validation.bloqueado) {
      globalThis.alert("Seguridad: Demasiados intentos fallidos. El sistema de invitaciones ha sido bloqueado por 24 horas para tu cuenta.");
    } else {
      globalThis.alert(
        `Validación de Identidad\n\nSi eres un profesional del sector salud, recuerda que debes validar tu identidad real primero.\n\nIntentos restantes: ${validation.intentos_restantes}`
      );
    }
    return false;
  };

  const dispatchAuth = async () => {
    try {
      const processedInvite = await processPendingInvite();
      const store = useProfileStore.getState();
      
      if (processedInvite || !store.hasChecked) {
        await store.fetchProfile(true);
      }

      const { isClinical, isProfileComplete } = useProfileStore.getState();
      let targetPath = '/app/search';
      let targetRole = 'CONSUMER';

      if (!isProfileComplete) {
        targetPath = '/app/identity';
      } else if (processedInvite) {
        targetPath = '/app/become-pro';
      } else if (isClinical) {
        targetPath = '/hub';
        targetRole = 'CLINICAL';
      }

      executeRedirect(targetPath, targetRole);

    } catch (error) {
      console.error("[AuthDispatcher] Error in dispatch:", error);
      executeRedirect('/app/search', 'CONSUMER');
    }
  };

  const executeRedirect = (path: string, role?: string) => {
    if (role === 'CONSUMER') setActiveRole('CONSUMER');
    navigate(path, { replace: true });
  };

  return (
    <div style={{ flex: 1, backgroundColor: '#0F172A', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <DynamicLoader 
        messages={[
          "Validando identidad...",
          "Asegurando entorno de trabajo...",
          "Preparando tu experiencia..."
        ]}
        color="#FFFFFF"
      />
    </div>
  );
}
